// 

import { useState } from "react";

function AddPlaces() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [checkingSession, setCheckingSession] = useState(true);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);

  const [form, setForm] = useState({
    name: "",
    description: "",
    latitude: "",
    longitude: "",
    type: "",
    tags: "",
    price: "",
    rating: "",
  });

  // On mount, check if we already have a valid session (e.g. page refresh)
  useState(() => {
    const checkSession = async () => {
      try {
        const res = await fetch("/api/session", {
          credentials: "include",
        });
        if (res.ok) {
          setIsAuthenticated(true);
        }
      } catch (err) {
        console.error("Session check failed:", err);
      } finally {
        setCheckingSession(false);
      }
    };
    checkSession();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError("");
    setLoggingIn(true);

    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include", // required so the session cookie gets set/sent
        body: JSON.stringify({ username, password }),
      });

      if (response.ok) {
        setIsAuthenticated(true);
        setPassword(""); // clear from memory once we're done with it
      } else {
        setLoginError("Incorrect username or password");
      }
    } catch (err) {
      console.error(err);
      setLoginError("Login failed. Please try again.");
    } finally {
      setLoggingIn(false);
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const payload = {
      ...form,
      latitude: parseFloat(form.latitude),
      longitude: parseFloat(form.longitude),
      tags: form.tags.split(",").map((tag) => tag.trim()),
      price: parseInt(form.price),
      rating: parseFloat(form.rating),
    };

    try {
      const response = await fetch("/api/add_place", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include", // send the session cookie so Flask can verify auth
        body: JSON.stringify(payload),
      });

      if (response.status === 401) {
        // session expired or was never valid server-side
        setIsAuthenticated(false);
        alert("Your session expired. Please log in again.");
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to add place");
      }

      alert("Place added!");
    } catch (err) {
      console.error(err);
      alert("Error adding place");
    }
  };

  // Avoid flashing the login form while we're still checking session state
  if (checkingSession) {
    return null; // or a small spinner if you'd prefer
  }

  // LOGIN POPUP
  if (!isAuthenticated) {
    return (
      <div style={styles.overlay}>
        <div style={styles.loginBox}>
          <h2>Login Required</h2>

          <form onSubmit={handleLogin}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={styles.input}
              autoComplete="username"
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              autoComplete="current-password"
            />

            {loginError && (
              <p style={styles.error}>{loginError}</p>
            )}

            <button type="submit" style={styles.button} disabled={loggingIn}>
              {loggingIn ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    );
  }

  // ADD PLACE FORM
  return (
    <div style={{ padding: 40 }}>
      <h1>Add Place</h1>

      <form onSubmit={submitForm}>
        <div>
          <input name="name" placeholder="Name" onChange={handleChange} />
        </div>

        <div>
          <textarea
            name="description"
            placeholder="Description"
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            name="latitude"
            placeholder="Latitude"
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            name="longitude"
            placeholder="Longitude"
            onChange={handleChange}
          />
        </div>

        <div>
          <input name="type" placeholder="Type" onChange={handleChange} />
        </div>

        <div>
          <input
            name="tags"
            placeholder="Tags (comma separated)"
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            name="price"
            placeholder="Price (Integer 1-5)"
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            name="rating"
            placeholder="Rating (1-5)"
            onChange={handleChange}
          />
        </div>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },

  loginBox: {
    width: 300,
    padding: 30,
    backgroundColor: "white",
    borderRadius: 10,
    textAlign: "center",
  },

  input: {
    width: "100%",
    padding: 10,
    marginBottom: 15,
    boxSizing: "border-box",
  },

  button: {
    width: "100%",
    padding: 10,
    cursor: "pointer",
  },

  error: {
    color: "#c0392b",
    fontSize: 14,
    marginTop: -8,
    marginBottom: 12,
  },
};

export default AddPlaces;